import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { useAppConfig } from '@/shared/hooks/api/appConfig'

export function useEmissionFactorValidation({ fuelType }: { fuelType: string }) {
  const { t } = useTranslation()
  const { combustionFuelTypesById } = useAppConfig().config

  const useEmissionFactorIsOutOfRangeValidation = useMemo(() => {
    const fuelTypeEmissionFactorLower = combustionFuelTypesById?.[fuelType]?.emissionFactorLower
    const fuelTypeEmissionFactorUpper = combustionFuelTypesById?.[fuelType]?.emissionFactorUpper

    if (fuelTypeEmissionFactorLower !== undefined && fuelTypeEmissionFactorUpper !== undefined) {
      return z
        .number()
        .refine(
          value => value >= fuelTypeEmissionFactorLower && value <= fuelTypeEmissionFactorUpper,
          {
            message: t('common:validations.emissionFactorIsOutOfRange', {
              minimumValue: fuelTypeEmissionFactorLower,
              maximumValue: fuelTypeEmissionFactorUpper
            })
          }
        )
    }

    return z.number()
  }, [fuelType, t, combustionFuelTypesById])

  return { useEmissionFactorIsOutOfRangeValidation }
}
